import moment from 'moment';

/* */
export const getBrandName = (code) => {
  let name;
  switch (code) {
    case '1':
    case 'A':
    case 'B':
    case 'C':
    case 'D':
    case 'E':
      name = 'CB';
      break;
    case '2':
    case '8':
    case '9':
      name = 'VISA';
      break;
    case '0':
    case '3':
      name = 'MASTERCARD';
      break;
    default:
      name = null;
  }
  return name;
};

/* */
export const createUuidFrom = (id) => `${id.slice(0, -12)}${moment().format('x').slice(-12)}`;
